package domain.usecase

import domain.repository.AuthenticationRepository

/**
 * Use case for handling user login
 */
class LoginUseCase(
    private val authRepository: AuthenticationRepository
) {
    
    /**
     * Initiates the login flow
     */
    fun execute() {
        authRepository.initiateLogin()
    }
}
